import React from 'react';
import { ThemeColorControl } from 'components/core/theme-color-control';

/**
 * Theme Tab Component
 * 
 * A settings tab component that contains theme customization controls.
 * This tab is used within the SettingsDialog to provide theme configuration options.
 * 
 * Features:
 * - Primary color customization for light mode
 * - Integration with the existing settings dialog structure
 * - Responsive design that works on both desktop and mobile
 * 
 * @param tabId - The ID of the current tab (used for consistency with other tabs)
 * @returns A theme configuration tab component
 */

interface ThemeTabProps {
    tabId: string;
}

export const ThemeTab: React.FC<ThemeTabProps> = () => {
    return (
        <div className="p-6 h-full overflow-auto">
            <div className="max-w-2xl">
                <div className="mb-6">
                    <h2 className="text-2xl font-semibold text-foreground mb-2">
                        Theme Settings
                    </h2>
                    <p className="text-muted-foreground">
                        Customize the appearance of your application. Changes will be saved automatically and persist across sessions.
                    </p>
                </div>

                <ThemeColorControl />
            </div>
        </div>
    );
};
